export const environment = {
  production: false,
  name: 'sandbox',
  authEnabled: true,
  // agw-tracer-v2 on sandbox. The v1 tracer is tracer-api.airgateway.net; the
  // Netlify CSP only allows the v2 hosts.
  tracerUrl: 'https://tracer-api-v2.airgateway.net',
  // NDC API + BookingPad, used only for the 'relaunch' deep link.
  apiUrl: 'https://api.airgateway.net',
  bpBackendUrl: 'https://backend.bookingpad.net',
  bpUrl: 'https://web.v2.bookingpad.net/',
  keycloakUrl: 'https://auth.airgateway.net',
  // Realm pre-selected on the login screen; the Admin tab switches to admins.
  keycloakRealm: 'agents',
  keycloakClientId: 'tracer',
};
